import React from 'react';
import { Card, Row } from 'antd';
import { _getProductsToUpdate } from '../../services';

import { SUPPLIER_URL } from '../../index';

class ProductTodoList extends React.PureComponent{

	render(){

		return (
			<Card
				style={{ marginTop: 8 }}
				title={"Products To Update"}>
				
				{this.renderProductList()}
				
			</Card>
		)
		
	}

	renderProductList = () => {

		const { loading, products, talkedToServer } = this.state;

		if(loading || !talkedToServer){
			return <Row>Loading...</Row>
		}

		if(products.length > 0){
			return products.map(
				product => (
					<Row>
						<a target={product._id} href={`${SUPPLIER_URL}/products/${product._id}`}>{product.title}</a>
					</Row>
				)
			)
		} else {
			return <Row>No Products</Row>
		}
	}

	state = {
		loading: false,
		products: [],
		talkedToServer: false
	}

	constructor(props){
		super(props);
		this.getProducts();
	}

	getProducts = (value) => {

		_getProductsToUpdate()
			.then( res => {
				this.setState({
					talkedToServer: true,
					products: res.data,
					loading: false
				})
			})

	}

}

export default ProductTodoList;


// WEBPACK FOOTER //
// ./src/components/product/todo-list.js